const envVars = process.env.NODE_ENV === 'development' || process.env.BASE_URL
    ? process.env
    : ((typeof window !== 'undefined' && window.env_vars) || process.env || {});

console.log(`Config used with ${process.env.BASE_URL ? 'process.env' : 'window.env_vars'}`);

const config = {
    url: envVars.BASE_URL || 'http://localhost:8000/',
    api: envVars.API_URL || 'http://localhost:8000/api',
    staticUrl: envVars.STATIC_URL || 'https://atremoplus-assets.s3.eu-central-1.amazonaws.com',
    ws: envVars.WEBSOCKET_URL || '',
    application: {
        name: 'AtremoPlus',
        email: 'contact@atremoplus.com',
        phone: '00 33 1 84 60 17 80',
        seo: {
            defaultTitle: '',
            defaultBaseline: 'Extraits naturels 100% d\'origine végétale',
        },
        options: {},
    },
    aws: {
        s3: {
            region: 'eu-west-3',
            bucket: envVars.S3_BUCKET || 'dev-atremoplus.com',
        },
    },
    bugsnag: { key: 'c727a9fa7bfe03c46a474c42351a480e' },
    google: {
        analytics: {
        //    trackingCode: 'UA-133347845-1',
           trackingCodeGA4: 'G-F9B3S7EKLH',
        },
    },
    ogone: {
        isReplaced: !!envVars.OGONE_REPLACED || false,
        url: envVars.OGONE_URL || 'https://ogone.test.v-psp.com/ncol/test', // https://secure.ogone.com/ncol/prod
        pspid: envVars.OGONE_PSPID || '',
        passphraseIn: envVars.OGONE_PASSPHRASE_IN || '',
    },
    paypal: {
        clientId: envVars.PAYPAL_CLIENT_ID || 'AV0yAePf0_ZrKnUcKzb0NIc2zbRabz3PthGhnFMg0stktB8k4nQltN_UCpozv8G35xVM01hiURDfYkB0',
        subscription: {
        },
    },
    v1: {
        url: 'https://v1.atremoplus.com/',
    },
};

// export default config;
process.env.NODE_ENV !== 'production' && console.log(config);
module.exports = config;
